export default __webpack_public_path__ + "static/media/Visibility.a4e65087.svg";